export default "__VITE_ASSET__CpTniHHa__"